<template>
  <div class="wa-step">
    <h2 class="wa-step__heading">
      {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.shared.metaTips.heading') }}
    </h2>
    <p class="wa-step__lead">
      {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.shared.metaTips.lead') }}
    </p>
    <div class="wa-tip-cards">
      <div class="wa-tip-card">
        <div class="wa-tip-card__icon wa-tip-card__icon--whatsapp">
          <i class="fa-brands fa-whatsapp" />
        </div>
        <div class="wa-tip-card__body">
          <h3 class="wa-tip-card__title">
            {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.shared.metaTips.wabaTitle') }}
          </h3>
          <p>{{ t('storeParameters.services.whatsappBusinessParameter.onboarding.shared.metaTips.wabaDescription') }}</p>
        </div>
      </div>
      <div class="wa-tip-card">
        <div class="wa-tip-card__icon wa-tip-card__icon--user">
          <i class="fa-solid fa-user" />
        </div>
        <div class="wa-tip-card__body">
          <h3 class="wa-tip-card__title">
            {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.shared.metaTips.displayNameTitle') }}
          </h3>
          <p>{{ t('storeParameters.services.whatsappBusinessParameter.onboarding.shared.metaTips.displayNameDescription') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
export default defineComponent({
  name: 'WhatsappMetaTipsStep',

  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>
